exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".el-date-editor .el-input[data-v-32acdaf2],.el-date-editor.el-input input[data-v-32acdaf2]{width:100%}input[data-v-32acdaf2]{width:100%;background-color:red!important}button[data-v-32acdaf2]{margin-left:10px;height:40px}h4[data-v-32acdaf2]{font-weight:700}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-32acdaf2","scoped":true,"hasInlineConfig":true}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/dashboard/my-data/additional-document.vue
// module id = 880
// module chunks = 0